import { openConfirmModal } from "components/ConfirmModal";
import { delDefiniteItemUri } from "data/api";
import loc from "i18next";
import { toastActionResult } from "data/toast";
import { postMessageTo } from "hooks/PostMessage/Utils";
import { ModalAction } from "hooks/PostMessage/Actions";

/**
 * Permanently deletes a definitely document from the Recycle Bin by itemUri
 *
 * @param {{ itemUri: string }} { itemUri }
 * @param {{ name: string }} { name }
 */

type Context = {
    itemUri: string,
    name: string,
};

class recyclebin_docClear {
    queueMultiple: boolean = true;
    logger: () => any = toastActionResult;
    shouldRender: boolean = true;

    render = async ({ name }: Context): Promise<boolean> => {
        this.shouldRender = false;
        return await openConfirmModal({
            body: loc.t("commandAction:recyclebin_docClear.confirmBody", {
                name,
            }),
            confirmButton: loc.t(
                "commandAction:recyclebin_docClear.confirmYes"
            ),
        });
    };

    execute = async ({ itemUri }: Context): Promise<boolean> => {
        try {
            const success = await delDefiniteItemUri(itemUri);

            if (success) {
                postMessageTo(ModalAction.Close, null, window);
            }

            return success;
        } catch (err) {
            console.warn(err);
            return false;
        }
    };

    report = async (success: boolean, { name }: Context): Promise<boolean> => {
        this.logger(success === true, "commandAction:recyclebin_docClear", {
            name,
        });
    };
}

export default recyclebin_docClear;
